/* @flow */

import * as React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';

import getConfig from 'next/config';
import withi18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import { Link, Router } from '../../../routes';
import FlexBox from '../../FlexBox';
import Container from '../../Container';
import navs from '../../../config/navs';

const {
  publicRuntimeConfig: {
    enableMargin,
  },
} = getConfig();

const Wrap = styled.div`
  width: 100%;
  line-height: 100%;
`;

const MainNavBox = styled(FlexBox)`
  width: 100%;
`;

const MainNavItem = styled.div`
  position: relative;
  padding: 20px 0;
  font-size: ${({ theme }) => theme.fontSizeMd};
  color: ${({ active }) => (active ? '#F0B90B' : '#fff')};
font-weight: ${({ active }) => active ? 'bold' : 'normal'};
  margin-right: 60px;
  cursor: pointer;
  text-transform: capitalize;
  transition: all 0.3s ease-in-out;
  :hover {
    color: #F0B90B;
  }
  :after {
    display: inline-block;
    content: ' ';
    width: 30px;
    height: 3px;
    background: #F0B90B;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    opacity: ${({ active, isActiveModule }) => (active && isActiveModule ? '1' : '0')};
    z-index: ${({ active, isActiveModule }) => (active && isActiveModule ? '1' : '-1')};
    transition: all 0.3s ease-in-out;
  }
`;

const SubNavBox = styled.div`
  width: 100%;
  background: #fff;
`;

const SubNavItem = styled.div`
  margin-right: 40px;
  > a {
    display: block;
    padding: 22px 0px;
    font-weight: 500;
    font-size: 14px;
    color: ${({ active }) => (active ? '#000' : '#848E9C')};
    transition: all 0.3s ease-in-out;
    text-transform: capitalize;
  }

  :hover {
    > a {
      color: #000;
    }
  }
`;

type RouterType = {
  pathname: string,
  asPath: string
};

type Props = {
  i18n: Object,
  locale: string,
  router: RouterType,
  userInfo: Object,
};

type State = {
  defaultActiveModule: string,
  activeModule: string,
  activePathname: string,
};

const mapStateToProps = ({ locale, userInfo }) => ({ locale, userInfo });

export default
@withi18n
@withRouter
@connect(mapStateToProps)
class Header extends React.PureComponent<Props, State> {
  static defaultProps = {
    i18n: {},
    locale: 'en',
    router: { pathname: '', asPath: '' },
    userInfo: {},
  };

  constructor(props: Props) {
    super(props);
    const { curModule, pathname } = this._getRouterInfo();
    this.state = {
      defaultActiveModule: curModule,
      activeModule: curModule,
      activePathname: pathname,
    };
  }

  componentDidMount() {
    this._setCurModules();
    // temporary
    const {
      router: { pathname },
    } = this.props;
    if (pathname !== '/usercenter/dashboard/overview') {
      window.scrollTo({ top: 140 });
    }
  }

  componentDidUpdate() {
    const {
      router: { pathname },
    } = this.props;
    if (pathname !== '/usercenter/dashboard/overview') {
      window.scrollTo({ top: 140 });
    }
  }

  _getRouterInfo = () => {
    const {
      router: { pathname, asPath },
    } = this.props;
    const curModule = pathname.split('/')[2];
    return {
      curModule,
      pathname: asPath,
    };
  };

  _setCurModules = () => {
    const { curModule } = this._getRouterInfo();
    this.setState({
      activeModule: curModule,
    });
  };

  _handleMouseOut = () => {
    const { defaultActiveModule } = this.state;
    this.setState({
      activeModule: defaultActiveModule,
    });
  };

  render() {
    const { i18n, locale, userInfo } = this.props;
    const { defaultActiveModule, activeModule, activePathname } = this.state;
    const subNavs = navs[activeModule] || { children: [] };
    return (
      <Wrap onMouseLeave={this._handleMouseOut}>
        <Container>
          <MainNavBox>
            {Object.keys(navs).map(key => {
              const { url, name, validator } = navs[key];
              if (typeof validator === 'function' && !validator(userInfo, enableMargin)) return null;
              return (
                <MainNavItem
                  key={key}
                  active={key === defaultActiveModule}
                  onClick={() => Router.pushRoute(`/${locale}${url}`)}
                  isActiveModule={activeModule === key}
                >
                  {getLabel(name, i18n)}
                </MainNavItem>
              );
            })}
          </MainNavBox>
        </Container>
        <SubNavBox>
          <Container>
            <FlexBox>
              {subNavs.children.map(({ url, name, validator }) => {
                if (typeof validator === 'function' && !validator(userInfo)) return null;
                return (
                  <SubNavItem key={name} active={activePathname.includes(url)}>
                    <Link scroll={false} route={`/${locale}${url}`}>{getLabel(name, i18n)}</Link>
                  </SubNavItem>
                );
              })}
            </FlexBox>
          </Container>
        </SubNavBox>
      </Wrap>
    );
  }
}
